import request from '@/utils/request'


// 查询加盟合作列表
export function listCooperation(query) {
  return request({
    url: '/biz/admin/user/cooperation/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询加盟合作分页
export function pageCooperation(query) {
  return request({
    url: '/biz/admin/user/cooperation/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询加盟合作详细
export function getCooperation(data) {
  return request({
    url: '/biz/admin/user/cooperation/detail',
    method: 'get',
    params: data
  })
}

// 新增加盟合作
export function addCooperation(data) {
  return request({
    url: '/biz/admin/user/cooperation/add',
    method: 'post',
    data: data
  })
}

// 修改加盟合作
export function updateCooperation(data) {
  return request({
    url: '/biz/admin/user/cooperation/edit',
    method: 'post',
    data: data
  })
}

// 删除加盟合作
export function delCooperation(data) {
  return request({
    url: '/biz/admin/user/cooperation/delete',
    method: 'post',
    data: data
  })
}

export function auditCooperation(data) {
  return request({
    url: '/biz/admin/user/cooperation/audit',
    method: 'post',
    data: data
  })
}
